import { Switch } from "@mui/material";
import { MDBCardHeader, MDBTable, MDBTableBody, MDBTableHead, } from 'mdb-react-ui-kit';
import React, { useEffect, useState } from 'react';
import { useDarkMode } from '../assets/DarkModeContext';
import { getRefCompetences, http } from '../services/httpService';
import AddNewCompetence from "./AddNewCompetence";
import CompetenceItem from "./CompetenceItem";
import CompetenceItemEdit from "./CompetenceItemEdit";

function GestionCompetences() {
    const [ competences, setCompetences ] = useState( [] );
    const [ categories, setCategories ] = useState( [] );
    const [ selectedLanguage, setSelectedLanguage ] = useState( 'fr' );
    const [ editingCompetence, setEditingCompetence ] = useState( null );
    const [ searchTerm, setSearchTerm ] = useState( "" );

    const { isDarkMode } = useDarkMode();

    useEffect( () => {
        const fetchCategories = async () => {
            try {
                const response = await http( 'ref/competences/categories/all' );
                if ( !response.ok ) {
                    throw new Error( 'Error al cargar categorías' );
                }
                const categoriesData = await response.json();
                setCategories( categoriesData );
            } catch ( error ) {
                console.error( 'Error al cargar categorías:', error );
            }
        };

        fetchCategories();
    }, [] );

    useEffect( () => {
        const loadData = async () => {
            getRefCompetences()
                .then( response => response.json() )
                .then( data => {
                    setCompetences( data );
                } )
                .catch( error => {
                    console.error( 'There was an error!', error );
                } );
        }

        loadData();
    }, [] )

    const handleLanguageChange = ( event ) => {
        const newLanguage = event.target.checked ? 'en' : 'fr';
        setSelectedLanguage( prevState => prevState !== newLanguage ? newLanguage : prevState );
    };

    const filteredCompetences = searchTerm === ''
        ? competences
        : competences.filter( competence => competence
            ?.competenceTranslations
            ?.[ selectedLanguage ]?.toLowerCase()
            ?.includes( searchTerm.toLowerCase() )
        );
    return (
        <div className='my-3'>
            <MDBCardHeader className='py-3'>
                <AddNewCompetence
                    categories={ categories }
                    selectedLanguage={ selectedLanguage }
                    setCompetences={ setCompetences }
                />
                <h5 className={ `text-center py-3 ${ isDarkMode ? 'text-white' : '' }` }>
                    <strong>Liste de compétences</strong>
                </h5>
                <div className='text-center'>
                    <input
                        type="text"
                        placeholder="Recherche par nom..."
                        value={ searchTerm }
                        onChange={ ( e ) => setSearchTerm( e.target.value ) }
                    />
                </div>
                <div className="d-flex align-items-center me-4 justify-content-center">
                    <i className="flag flag-france"></i>
                    <Switch
                        checked={ selectedLanguage === 'en' }
                        onChange={ handleLanguageChange }
                        name="languageSwitch"
                        inputProps={ { 'aria-label': 'language switch' } }
                    />
                    <i className="flag flag-united-kingdom"></i>
                </div>
                <MDBTable>
                    <MDBTableHead>
                        <tr className={ `${ isDarkMode ? 'text-white' : '' }` }>
                            <th>Catégorie</th>
                            <th>Nom de compétence { selectedLanguage === 'fr'
                                ? <i className="flag flag-france"></i>
                                : <i className="flag flag-united-kingdom"></i> }
                            </th>
                            <th>Description { selectedLanguage === 'fr'
                                ? <i className="flag flag-france"></i> :
                                <i className="flag flag-united-kingdom"></i> }
                            </th>
                            <th>Actions</th>
                        </tr>
                    </MDBTableHead>
                    <MDBTableBody style={ { overflowX: 'auto' } }>
                        { filteredCompetences && filteredCompetences.length > 0
                            ? (
                                filteredCompetences
                                    .sort( ( a, b ) => {
                                            const aVal = a.competenceTranslations?.[ selectedLanguage ];
                                            const bVal = b.competenceTranslations?.[ selectedLanguage ];

                                            if ( aVal == null && bVal == null ) return 0;
                                            if ( aVal == null ) return -1;
                                            if ( bVal == null ) return 1;

                                            return aVal.localeCompare( bVal );
                                        }
                                    )
                                    .map( ( competence ) =>
                                        editingCompetence === competence.id
                                            ? <CompetenceItemEdit
                                                key={ competence.id }
                                                item={ competence }
                                                selectedLanguage={ selectedLanguage }
                                                categories={ categories }
                                                setEditingCompetence={ setEditingCompetence }
                                                setCompetences={ setCompetences }
                                            />
                                            : <CompetenceItem
                                                key={ competence.id }
                                                item={ competence }
                                                categories={ categories }
                                                selectedLanguage={ selectedLanguage }
                                                setEditingCompetence={ setEditingCompetence }
                                                setCompetences={ setCompetences }
                                            />
                                    )
                            )
                            : (
                                <tr>
                                    <td colSpan="6">
                                        <div>
                                            <img className="loader-image" src="/spinner-alcyone.png"
                                                 alt="Loading..."/>
                                        </div>
                                    </td>
                                </tr>
                            ) }
                    </MDBTableBody>
                </MDBTable>
            </MDBCardHeader>
        </div>
    );
}

export default GestionCompetences;
